export function getOptionValueNameById(options, id, key = 'name') {
  const option = options ? options.find((_option) => _option.id === id) : null;
  return option ? option[key] : null;
}

export default getOptionValueNameById;



// WEBPACK FOOTER //
// ./src/common/utils/getOptionValueNameById.js